// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetMarketInstruments (params?: {}): Promise<Dict>;
    publicGetMarketInstrumentsHistory (params?: {}): Promise<Dict>;
    publicGetMarketTickers (params?: {}): Promise<Dict>;
    publicGetMarketBooks (params?: {}): Promise<Dict>;
    publicGetMarketTrades (params?: {}): Promise<Dict>;
    publicGetMarketMarkPrice (params?: {}): Promise<Dict>;
    publicGetMarketFundingRate (params?: {}): Promise<Dict>;
    publicGetMarketFundingRateHistory (params?: {}): Promise<Dict>;
    publicGetMarketCandles (params?: {}): Promise<Dict>;
    publicGetMarketIndexCandles (params?: {}): Promise<Dict>;
    publicGetMarketMarkPriceCandles (params?: {}): Promise<Dict>;
    publicGetMarketPositionTiers (params?: {}): Promise<Dict>;
    publicGetSpotMarketInstruments (params?: {}): Promise<Dict>;
    publicGetSpotMarketTickers (params?: {}): Promise<Dict>;
    publicGetSpotMarketBooks (params?: {}): Promise<Dict>;
    publicGetSpotMarketTrades (params?: {}): Promise<Dict>;
    publicGetSpotMarketCandles (params?: {}): Promise<Dict>;
    privateGetAssetBalances (params?: {}): Promise<Dict>;
    privateGetAssetBills (params?: {}): Promise<Dict>;
    privateGetAssetWithdrawalHistory (params?: {}): Promise<Dict>;
    privateGetAssetDepositHistory (params?: {}): Promise<Dict>;
    privateGetAssetDepositAddress (params?: {}): Promise<Dict>;
    privateGetAccountConfig (params?: {}): Promise<Dict>;
    privateGetAssetCurrencies (params?: {}): Promise<Dict>;
    privateGetAccountBalance (params?: {}): Promise<Dict>;
    privateGetAccountPositions (params?: {}): Promise<Dict>;
    privateGetAccountPositionsHistory (params?: {}): Promise<Dict>;
    privateGetAccountFundingFees (params?: {}): Promise<Dict>;
    privateGetAccountMarginMode (params?: {}): Promise<Dict>;
    privateGetAccountPositionMode (params?: {}): Promise<Dict>;
    privateGetAccountLeverageInfo (params?: {}): Promise<Dict>;
    privateGetAccountBatchLeverageInfo (params?: {}): Promise<Dict>;
    privateGetTradeOrdersPending (params?: {}): Promise<Dict>;
    privateGetTradeOrderDetail (params?: {}): Promise<Dict>;
    privateGetTradeOrdersTpslPending (params?: {}): Promise<Dict>;
    privateGetTradeOrderTpslDetail (params?: {}): Promise<Dict>;
    privateGetTradeOrdersAlgoPending (params?: {}): Promise<Dict>;
    privateGetTradeOrdersHistory (params?: {}): Promise<Dict>;
    privateGetTradeOrdersTpslHistory (params?: {}): Promise<Dict>;
    privateGetTradeOrdersAlgoHistory (params?: {}): Promise<Dict>;
    privateGetTradeFillsHistory (params?: {}): Promise<Dict>;
    privateGetTradeOrderPriceRange (params?: {}): Promise<Dict>;
    privateGetAffiliateBasic (params?: {}): Promise<Dict>;
    privateGetAffiliateReferralCode (params?: {}): Promise<Dict>;
    privateGetAffiliateInvitees (params?: {}): Promise<Dict>;
    privateGetAffiliateSubInvitees (params?: {}): Promise<Dict>;
    privateGetAffiliateSubAffiliates (params?: {}): Promise<Dict>;
    privateGetAffiliateInviteesDailyInfo (params?: {}): Promise<Dict>;
    privateGetCopytradingInstruments (params?: {}): Promise<Dict>;
    privateGetCopytradingConfig (params?: {}): Promise<Dict>;
    privateGetCopytradingAccountBalance (params?: {}): Promise<Dict>;
    privateGetCopytradingAccountPositionsByOrder (params?: {}): Promise<Dict>;
    privateGetCopytradingAccountPositionsDetailsByOrder (params?: {}): Promise<Dict>;
    privateGetCopytradingAccountPositionsByContract (params?: {}): Promise<Dict>;
    privateGetCopytradingAccountPositionMode (params?: {}): Promise<Dict>;
    privateGetCopytradingAccountLeverageInfo (params?: {}): Promise<Dict>;
    privateGetCopytradingTradeOrdersPending (params?: {}): Promise<Dict>;
    privateGetCopytradingTradePendingTpslByContract (params?: {}): Promise<Dict>;
    privateGetCopytradingTradePositionHistoryByOrder (params?: {}): Promise<Dict>;
    privateGetCopytradingTradeOrdersHistory (params?: {}): Promise<Dict>;
    privateGetCopytradingTradePendingTpslByOrder (params?: {}): Promise<Dict>;
    privateGetUserQueryApikey (params?: {}): Promise<Dict>;
    privateGetSpotTradeFillsHistory (params?: {}): Promise<Dict>;
    privateGetSpotTradeOrdersPending (params?: {}): Promise<Dict>;
    privateGetSpotTradeOrderDetail (params?: {}): Promise<Dict>;
    privateGetSpotTradeOrdersAlgoPending (params?: {}): Promise<Dict>;
    privateGetSpotTradeOrdersHistory (params?: {}): Promise<Dict>;
    privateGetSpotTradeOrdersAlgoHistory (params?: {}): Promise<Dict>;
    privateGetSpotTradeOrderPriceRange (params?: {}): Promise<Dict>;
    privatePostAssetTransfer (params?: {}): Promise<Dict>;
    privatePostAssetDemoApplyMoney (params?: {}): Promise<Dict>;
    privatePostAssetWithdrawalApply (params?: {}): Promise<Dict>;
    privatePostAccountSetMarginMode (params?: {}): Promise<Dict>;
    privatePostAccountSetPositionMode (params?: {}): Promise<Dict>;
    privatePostAccountSetLeverage (params?: {}): Promise<Dict>;
    privatePostTradeOrder (params?: {}): Promise<Dict>;
    privatePostTradeBatchOrders (params?: {}): Promise<Dict>;
    privatePostTradeOrderTpsl (params?: {}): Promise<Dict>;
    privatePostTradeOrderAlgo (params?: {}): Promise<Dict>;
    privatePostTradeCancelOrder (params?: {}): Promise<Dict>;
    privatePostTradeCancelBatchOrders (params?: {}): Promise<Dict>;
    privatePostTradeCancelTpsl (params?: {}): Promise<Dict>;
    privatePostTradeCancelAlgo (params?: {}): Promise<Dict>;
    privatePostTradeAmendOrder (params?: {}): Promise<Dict>;
    privatePostTradeAmendBatchOrders (params?: {}): Promise<Dict>;
    privatePostTradeAmendTpsl (params?: {}): Promise<Dict>;
    privatePostTradeAmendAlgo (params?: {}): Promise<Dict>;
    privatePostTradeClosePosition (params?: {}): Promise<Dict>;
    privatePostSpotTradeOrder (params?: {}): Promise<Dict>;
    privatePostSpotTradeBatchOrders (params?: {}): Promise<Dict>;
    privatePostSpotTradeOrderAlgo (params?: {}): Promise<Dict>;
    privatePostSpotTradeCancelOrder (params?: {}): Promise<Dict>;
    privatePostSpotTradeCancelBatchOrders (params?: {}): Promise<Dict>;
    privatePostSpotTradeCancelAlgo (params?: {}): Promise<Dict>;
    privatePostCopytradingAccountSetPositionMode (params?: {}): Promise<Dict>;
    privatePostCopytradingAccountSetLeverage (params?: {}): Promise<Dict>;
    privatePostCopytradingTradePlaceOrder (params?: {}): Promise<Dict>;
    privatePostCopytradingTradeCancelOrder (params?: {}): Promise<Dict>;
    privatePostCopytradingTradePlaceTpslByContract (params?: {}): Promise<Dict>;
    privatePostCopytradingTradeCancelTpslByContract (params?: {}): Promise<Dict>;
    privatePostCopytradingTradePlaceTpslByOrder (params?: {}): Promise<Dict>;
    privatePostCopytradingTradeCancelTpslByOrder (params?: {}): Promise<Dict>;
    privatePostCopytradingTradeClosePositionByOrder (params?: {}): Promise<Dict>;
    privatePostCopytradingTradeClosePositionByContract (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
